export default class Mapa {
    constructor() {
        this.sections = document.querySelectorAll('.component-mapa');
        this.ready();
    }

    ready() {

        this.sections.forEach(section => {
            const mapLinks = section.querySelectorAll('.state')

            mapLinks.forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    const estado = link.id
                    section.querySelectorAll('.modal').forEach(modal => {
                        modal.classList.remove('active')
                    })
                    const mapRegion = section.querySelector('#modal-'+estado)
                    if(mapRegion) {
                        section.querySelector('#modal-'+estado).classList.add('active')
                        section.querySelector('#modal-'+estado).querySelector('.btnCloseModal').addEventListener('click', () => {
                            section.querySelector('#modal-'+estado).classList.remove('active')
                        });
                    }
                });
                
            })

            const selectState = section.querySelector('#formMap select')
            selectState.addEventListener('change', () => {
                const estado = selectState.value
                section.querySelectorAll('.modal').forEach(modal => {
                    modal.classList.remove('active')
                })
                const mapRegion = section.querySelector('#modal-'+estado)
                if(mapRegion) {
                    section.querySelector('#modal-'+estado).classList.add('active')
                    section.querySelector('#modal-'+estado).querySelector('.btnCloseModal').addEventListener('click', () => {
                        section.querySelector('#modal-'+estado).classList.remove('active')
                    });
                }

            })

        })

    }

}

if (document.querySelector('.component-mapa')) {
    new Mapa();
}